import controller from './activations.controller';
import template from './activations.html';

const servicesActivationsComponent = {
  restrict: 'E',
  template,
  controller
};

export default servicesActivationsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/activations/activations.component.js
 **/